// The error-code map. `translateDesktopError` used to live here and
// was the ONLY i18next consumer in the whole thirteen-file subtree; the owner
// ruled i18next out of this package (§0 ruling 4), so it stays app-side at
// `@/tauri/errors` and is rebuilt on the two pure functions below.
import { audioErrorCodes } from './audio';
import { authErrorCodes } from './auth';
import { chronicleErrorCodes } from './chronicle';
import { generalErrorCodes } from './general';
import { emisErrorCodes } from './integration-emis';
import { gdtErrorCodes } from './integration-gdt';
import { genieErrorCodes } from './integration-genie';
import { onlineSessionErrorCodes } from './online-session';
import { recordingErrorCodes } from './recording';
import { sessionErrorCodes } from './session';
import { type ErrorCodeMap } from './types';

const ERROR_CODE_MAP: ErrorCodeMap = {
  ...audioErrorCodes,
  ...recordingErrorCodes,
  ...chronicleErrorCodes,
  ...sessionErrorCodes,
  ...authErrorCodes,
  ...gdtErrorCodes,
  ...genieErrorCodes,
  ...emisErrorCodes,
  ...onlineSessionErrorCodes,
  ...generalErrorCodes,
};

const FALLBACK_KEY = 'desktop.errors.unknown';

export function resolveDesktopErrorKey(errorCode?: string): string {
  if (errorCode && ERROR_CODE_MAP[errorCode]) {
    return ERROR_CODE_MAP[errorCode];
  }
  return FALLBACK_KEY;
}

// Reads the map DIRECTLY, because `resolveDesktopErrorKey(code) !==
// FALLBACK_KEY` is not the same question: `ONLINE_SESSION_INTERNAL` maps
// explicitly to `desktop.errors.unknown`, and calling it unmapped would show the
// raw Rust message where the translated copy has always been. Why the app-side
// translator needs the distinction at all: `src/tauri/errors.ts`.
export function hasDesktopErrorMapping(errorCode?: string): boolean {
  return Boolean(errorCode) && ERROR_CODE_MAP[errorCode as string] !== undefined;
}
